import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import {
  SEOPagesApiResponse,
  SEOPagesResponse,
} from "../types/seo-pages-types";

export const fetchSEOPages = createAsyncThunk(
  "seoPages/fetchSEOPages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<SEOPagesApiResponse>(
        "/seo-pages"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type SEOState = {
  seoPages: SEOPagesResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: SEOState = {
  seoPages: [],
  status: "idle",
  error: null,
};

const seoPagesSlice = createSlice({
  name: "seoPages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSEOPages.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSEOPages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.seoPages = action.payload.data;
      })
      .addCase(fetchSEOPages.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default seoPagesSlice.reducer;
